import { call, put, takeEvery } from "redux-saga/effects"

import {
  GET_USERS,
  GET_USER_DETAIL,
  MANAGE_USER,
  GET_AUTHORIZATION_GROUPS,
} from "./actionTypes"

import {
  getUsersSuccess,
  getUsersFail,
  getUserDetailSuccess,
  getUserDetailFail,
  manageUserSuccess,
  manageUserFail,
  getAuthorizationGroupsSuccess,
  getAuthorizationGroupsFail,
} from "./actions"

import { getUsers, manageUser, getAuthorizationGroups } from "../../helpers/backend_helper"

function* fetchUsers({ payload: { options, history } }) {
  try {
    const response = yield call(getUsers, options)
    yield put(getUsersSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* fetchUserDetail({ payload: { options, history } }) {
  try {
    const response = yield call(getUsers, options)
    // The API returns a user object directly when userID is provided
    // If it's an array (list response), get the first user, otherwise use the response as-is
    const userDetail = Array.isArray(response) && response.length > 0 ? response[0] : response
    yield put(getUserDetailSuccess(userDetail))
  } catch (error) {
    yield put(getUserDetailFail(error))
  }
}

function* onManageUser({ payload: { data, options, history } }) {
  try {
    const response = yield call(manageUser, data, options)
    yield put(manageUserSuccess(response))

    // Refresh the users list using pagination from options
    const refreshPagination = options?.refreshPagination || {}
    try {
      const refreshResponse = yield call(getUsers, {
        headers: { "input-parameters": { keyword: refreshPagination.keyword || "" } },
        pagination: { startIndex: refreshPagination.startIndex ?? 0 },
      })
      yield put(getUsersSuccess(refreshResponse))
    } catch (refreshError) {
      if (refreshError.message === "No content available") {
        yield put(getUsersSuccess([]))
      } else {
        yield put(getUsersFail(refreshError))
      }
    }
  } catch (error) {
    yield put(manageUserFail(error))
  }
}

function* fetchAuthorizationGroups({ payload: { options, history } }) {
  try {
    const response = yield call(getAuthorizationGroups, options)
    yield put(getAuthorizationGroupsSuccess(response))
  } catch (error) {
    yield put(getAuthorizationGroupsFail(error))
  }
}

function* usersSaga() {
  yield takeEvery(GET_USERS, fetchUsers)
  yield takeEvery(GET_USER_DETAIL, fetchUserDetail)
  yield takeEvery(MANAGE_USER, onManageUser)
  yield takeEvery(GET_AUTHORIZATION_GROUPS, fetchAuthorizationGroups)
}

export default usersSaga
